import { z } from "@core/zod";

export const GlyphSchema = z.enum([
  "apple",
  "beef",
  "cookie",
  "cup-soda",
  "droplet",
  "egg",
  "fish",
  "milk",
  "pizza",
  "utensils",
  "wheat",
]);

export type Glyph = z.infer<typeof GlyphSchema>;
